import { Schema, Node } from 'prosemirror-model';
import { EditorContentConfiguration } from '../configurations/editor-content';
export class ContentBuilder {

    constructor(private schema: Schema) {
    }

    createParagraph(contentConfiguration: EditorContentConfiguration, textContent?: string): Node {
        let p: Node;
        const attributes = {
            direction: contentConfiguration.documentTextDirection,
            textAlign: contentConfiguration.paragraphAlign,
            fontFamily: contentConfiguration.documentFontFamily,
            fontSize: contentConfiguration.documentFontSize,
        };
        const schema = this.schema;
        if (textContent) {
            p = schema.node(schema.nodes.paragraph, attributes, [schema.text(textContent)]);
        } else {
            p = schema.node(schema.nodes.paragraph, attributes, null);
        }
        return p;
    }

    createStartDoc(contentConfiguration: EditorContentConfiguration): Node {
        const schema = this.schema;
        const startNode = this.createParagraph(contentConfiguration);
        const div = schema.node(schema.nodes.main, null, [startNode]);
        return schema.node(schema.nodes.doc, null, [div]);
    }
}
